export class CreateQRCodeParams {
  texte: string;
  width: number;
  height: number;
  dpiX: number;
  dpiY: number;
}
